import { render, staticRenderFns } from "./ProcessDeterminationDocumentAdd.vue?vue&type=template&id=56527fef&scoped=true"
import script from "./ProcessDeterminationDocumentAdd.vue?vue&type=script&lang=js"
export * from "./ProcessDeterminationDocumentAdd.vue?vue&type=script&lang=js"
import style0 from "./ProcessDeterminationDocumentAdd.vue?vue&type=style&index=0&id=56527fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56527fef",
  null
  
)

export default component.exports